import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

type PNotificationItem = {
  NotificationIcon: React.FC;
  isHighlighted: boolean;
  onClick?: () => void;
};

const useStyles = makeStyles<void, { isHighlighted: boolean }>(() => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '20px 1fr',
    gridGap: '10px',
    alignItems: 'center',
    padding: '2px 10px',
    wordBreak: 'break-word',
    background: ({ isHighlighted }) => (isHighlighted ? 'unset' : '#f7fbfe'),
  },
}));

export const NotificationItemContainer: React.FC<PNotificationItem> = (
  props,
) => {
  const {
    NotificationIcon,
    isHighlighted,
    children,
    onClick = () => {},
  } = props;
  const classes = useStyles({ isHighlighted });

  return (
    <div className={classes.root} onClick={onClick}>
      <div>
        <NotificationIcon />
      </div>
      <div>{children}</div>
    </div>
  );
};
